import React from 'react';
import { formatTokens } from '../../utils/format-tokens';

interface TokenBarProps {
  label: string;
  value: number;
  total: number;
  color: string;
}

export const TokenBar: React.FC<TokenBarProps> = ({ label, value, total, color }) => {
  const pct = total > 0 ? (value / total) * 100 : 0;
  return (
    <div className="flex items-center space-x-3">
      <span className="text-sm text-gray-400 w-16">{label}</span>
      <div className="flex-1 bg-gray-700 rounded-full h-3">
        <div className={`${color} rounded-full h-3`} style={{ width: `${pct}%` }} />
      </div>
      <span className="text-sm text-white w-20 text-right">{formatTokens(value)}</span>
      <span className="text-xs text-gray-500 w-12 text-right">{pct.toFixed(1)}%</span>
    </div>
  );
};
